import Vue from 'vue'
import Vuex from 'vuex'
import collabs from './collabs'
import ideas from './ideas'
import strategy from './strategy'
import videos from './videos'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  modules: {
    collabs,
    ideas,
    strategy,
    videos,
  },
  state: {
    changes: false,
  },
  mutations: {
    hasChanges(state) {
      state.changes = true
    },
    noChanges(state) {
      state.changes = false
    },
  },
  actions: {
    saveState(context) {
      // videos
      const videoEdits = context.rootState.creator.videos.videos.filter(video => {
        return video.change
      })
      videoEdits.forEach(video => {
        if (video.change === 'create') {
          context.dispatch('createVideo', video)
        } else if (video.change === 'update') {
          context.dispatch('updateVideo', video)
        }
      })
      context.rootState.creator.videos.deletedVideos.forEach(video => {
        context.dispatch('deleteVideo', video)
      })
      // pillars
      const pillarEdits = context.rootState.creator.strategy.pillars.filter(pillar => {
        return pillar.change || pillar.keywordChange
      })
      pillarEdits.forEach(pillar => {
        if (pillar.change === 'create') {
          context.dispatch('createPillar', pillar)
            .then(() => {
              const pillarID = pillar.pillarID
              pillar.keywords.forEach(keyword => {
                context.dispatch('createKeyword', { pillarID, keyword })
              })
            })
        } else {
          if (pillar.change === 'update') {
            context.dispatch('updatePillar', pillar)
          }
          if (pillar.keywordChange) {
            pillar.keywords.forEach(keyword => {
              const pillarID = pillar.pillarID
              if (keyword.change === 'create') {
                context.dispatch('createKeyword', { pillarID, keyword })
              } else if (keyword.change === 'update') {
                context.dispatch('updateKeyword', { pillarID, keyword })
              }
            })
          }
        }
      })
      context.rootState.creator.strategy.deletedPillars.forEach(pillar => {
        context.dispatch('deletePillar', pillar)
      })
      context.rootState.creator.strategy.deletedKeywords.forEach(keyword => {
        context.dispatch('deleteKeyword', keyword)
      })
      // boards
      const boardEdits = context.rootState.creator.ideas.boards.filter(board => {
        return board.change || board.pinChange
      })
      boardEdits.forEach(board => {
        if (board.change === 'create') {
          context.dispatch('createBoard', board)
            .then(() => {
              const boardID = board.boardID
              board.pins.forEach(pin => {
                context.dispatch('createPin', { boardID, pin })
              })
            })
        } else {
          if (board.change === 'update') {
            context.dispatch('updateBoard', board)
          }
          if (board.pinChange) {
            board.pins.forEach(pin => {
              const boardID = board.boardID
              if (pin.change === 'create') {
                context.dispatch('createPin', { boardID, pin })
              } else if (pin.change === 'update') {
                context.dispatch('updatePin', { boardID, pin })
              }
            })
          }
        }
      })
      context.rootState.creator.ideas.deletedBoards.forEach(board => {
        context.dispatch('deleteBoard', board)
      })
      context.rootState.creator.ideas.deletedPins.forEach(pin => {
        context.dispatch('deletePin', pin)
      })
      // collabs
      const collabEdits = context.rootState.creator.collabs.collabs.filter(collab => {
        return collab.change
      })
      collabEdits.forEach(collab => {
        if (collab.change === 'create') {
          context.dispatch('createCollab', collab)
        }
      })
      context.rootState.creator.collabs.deletedCollabs.forEach(collab => {
        context.dispatch('deleteCollab', collab)
      })
      context.commit('noChanges')
    },
    createVideo(context, payload) {
      delete payload.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .add(payload.data)
    },
    updateVideo(context, payload) {
      delete payload.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .doc(payload.videoID)
        .set(payload.data)
    },
    deleteVideo(context, payload) {
      console.log('deleteVideo')
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('videos')
        .doc(payload.videoID)
        .delete()
    },
    createPillar(context, payload) {
      delete payload.change
      console.log('createPillar')
      console.log(payload)
      return firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .add(payload.data)
        .then(doc => {
          payload.pillarID = doc.id
        })
    },
    updatePillar(context, payload) {
      delete payload.change
      console.log(payload)
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .doc(payload.pillarID)
        .set(payload.data)
    },
    async deletePillar(context, payload) {
      console.log('deletePillar')
      console.log(payload)
      const docRef = await firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .doc(payload.pillarID)
      docRef.collection('keywords')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            doc.ref.delete()
          })
        })
      docRef.delete()
    },
    createKeyword(context, payload) {
      payload.keyword.pillarID = payload.pillarID
      delete payload.keyword.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .doc(payload.pillarID)
        .collection('keywords')
        .add(payload.keyword.data)
        .then(doc => {
          payload.keyword.keywordID = doc.id
        })
    },
    updateKeyword(context, payload) {
      console.log('updateKeyword')
      console.log(payload)
      delete payload.keyword.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .doc(payload.pillarID)
        .collection('keywords')
        .doc(payload.keyword.keywordID)
        .set(payload.keyword.data)
    },
    deleteKeyword(context, payload) {
      console.log('deleteKeyword')
      console.log(payload)
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('pillars')
        .doc(payload.pillarID)
        .collection('keywords')
        .doc(payload.keywordID)
        .delete()
    },
    createBoard(context, payload) {
      delete payload.change
      console.log('createBoard')
      console.log(payload)
      return firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .add(payload.data)
        .then(doc => {
          payload.boardID = doc.id
        })
    },
    updateBoard(context, payload) {
      delete payload.change
      console.log(payload)
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .doc(payload.boardID)
        .set(payload.data)
    },
    async deleteBoard(context, payload) {
      console.log('deleteBoard')
      console.log(payload)
      // need to execute cloud function to delete document and subcollections
      const docRef = await firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .doc(payload.boardID)
      docRef.collection('pins')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            doc.ref.delete()
          })
        })
      docRef.delete()
    },
    createPin(context, payload) {
      payload.pin.boardID = payload.boardID
      delete payload.pin.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .doc(payload.boardID)
        .collection('pins')
        .add(payload.pin.data)
        .then(doc => {
          payload.pin.pinID = doc.id
        })
    },
    updatePin(context, payload) {
      console.log('updatePin')
      console.log(payload)
      delete payload.pin.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .doc(payload.boardID)
        .collection('pins')
        .doc(payload.pin.pinID)
        .set(payload.pin.data)
    },
    deletePin(context, payload) {
      console.log('deletePin')
      console.log(payload)
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .doc(payload.boardID)
        .collection('pins')
        .doc(payload.pinID)
        .delete()
    },
    createCollab(context, payload) {
      delete payload.change
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('collabs')
        .add(payload.data)
    },
    deleteCollab(context, payload) {
      console.log('deleteCollab')
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('collabs')
        .doc(payload.collabID)
        .delete()
    },
  },
  getters: {},
}

// loop pillars
// => create pillars
//  => create keywords
// => update pillars
//  => create keywords
//  => delete keywords
//  => update keywords
//
// loop deletedPillars
// => delete pillars
